<!--
 * @Author: RYL
 * @Description: 
 * @Date: 2020-10-20 14:40:17
 * @LastEditTime: 2022-03-31 13:36:57
-->
<template>
  <div class="add-group">
    <div class="new-group" v-if="addType === 'new'">
      <el-form
        :model="editData"
        ref="groupForm"
        label-width="150px"
        label-position="right"
        :rules="rules"
      >
        <el-form-item
          :label="$t('lang.FastAccess.projectName') + '：'"
          prop="groupName"
        >
          <el-input
            style="width: 3.5rem"
            size="mini"
            clearable
            :placeholder="$t('lang.FastAccess.pleaseName')"
            v-model="editData.groupName"
          ></el-input>
          <span class="check-group" @click="setAddType('select')">{{
            $t("lang.FastAccess.selectProject")
          }}</span>
        </el-form-item>
        <el-form-item
          :label="$t('lang.FastAccess.projectType') + '：'"
          prop="groupMonitorType"
        >
          <el-select
            v-model="editData.groupMonitorType"
            :placeholder="$t('lang.FastAccess.projectType')"
            filterable
            clearable
            size="mini"
          >
            <el-option
              :label="$t('lang.FastAccess.genericType')"
              value="0"
            ></el-option>
            <el-option label="中建三局" value="1"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          :label="$t('lang.FastAccess.ownCustomer') + '：'"
          prop="groupCtid"
          v-if="
            user_iscustomer == 2 || (user_iscustomer == 1 && user_ctid == 0)
          "
        >
          <el-select
            v-model="editData.groupCtid"
            :placeholder="$t('lang.FastAccess.pleaseProject')"
            filterable
            clearable
            size="mini"
          >
            <el-option
              v-for="item in Customer"
              :key="item.c_id"
              :label="item.c_name"
              :value="item.c_id"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          :label="$t('lang.FastAccess.BelogingUser') + '：'"
          prop="uid"
          v-if="user_iscustomer == 0 || user_ctid != 0"
        >
          <el-select
            v-model="editData.uid"
            :placeholder="$t('lang.groupinglist.Optional')"
            filterable
            clearable
            size="mini"
          >
            <el-option
              v-for="item in UserList"
              :key="item.user_id"
              :label="item.username"
              :value="item.user_id"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          :label="$t('lang.FastAccess.firstGrouping')"
          prop="groupLevel1"
        >
          <el-select
            v-model="editData.groupPid"
            filterable
            clearable
            :placeholder="$t('lang.groupinglist.selector')"
            size="mini"
          >
            <el-option
              v-for="item in projectList"
              :key="item.groupId"
              :label="item.groupName"
              :value="item.groupId"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-form>
    </div>
    <div class="select-group" v-else-if="addType === 'select'">
      <project-select ref="projectSelect">
        <span
          class="check-group"
          slot="newProject"
          @click="setAddType('new')"
          >{{ $t("lang.FastAccess.backNewProject") }}</span
        >
      </project-select>
    </div>
    <div style="text-align: center; margin-top: 30px">
      <el-button size="mini" type="primary" @click="next">{{
        $t("lang.FastAccess.next")
      }}</el-button>
    </div>
  </div>
</template>
<script>
import { addProject } from "@/mixins/addProject";
import {
  editProjectGroup,
  addProjectGroup,
} from "@/api/cloudMonitor/projectGroup";
import projectSelect from "../../components/projectSelect";
export default {
  mixins: [addProject],
  components: {
    projectSelect,
  },
  data() {
    return {
      radioValue: "新建项目",
      addType: "new", // 标志目前是选择已有的项目还是用户新建项目
    };
  },
  mounted() {
    if (
      this.user_iscustomer == 2 ||
      (this.user_iscustomer == 1 && this.user_ctid == 0)
    ) {
      this.getCustomer();
    } else if (this.user_iscustomer == 0 || this.user_ctid != 0) {
      this.getUser();
    }
    this.getFirstList();
  },
  methods: {
    next() {
      let checkResult = false;
      if (this.addType === "select") {
        // 对选择表单进行验证
        checkResult = this.$refs.projectSelect.checkForm();
        if (checkResult === true) {
          this.$emit("next");
        }
      } else if (this.addType === "new") {
        // 若是新建项目则在进入下一步之前请求接口添加设备项目分组
        this.$refs["groupForm"].validate((valid) => {
          if (valid) {
            checkResult = true;
            // 信息判断是编辑还是增加
            if (this.editData.groupPid) {
              this.editData.groupLevel = 2;
            } else {
              this.editData.groupLevel = 1;
              this.editData.groupPid = 0;
            }
            if (this.editData.id) {
              //编辑（用户点击上一步时即是对已添加的项目进行修改）
              editProjectGroup(this.editData)
                .then((res) => {
                  if (res.data.code === 0) {
                    this.$emit("next");
                  } else {
                    this.$message.error(this.$t('lang.FastAccess.Failedtoeditgroup'));
                  }
                })
                .catch(() => {
                  this.$message.error(this.$t('lang.FastAccess.tryagain'));
                });
            } else {
              // 添加
              addProjectGroup(this.editData)
                .then((res) => {
                  if (res.data.code === 0) {
                    this.$set(this.editData, "id", res.data.data);
                    this.$emit("next");
                  } else {
                    this.$message.error(this.$t('lang.FastAccess.Failedtoaddgroup'));
                  }
                })
                .catch(() => {
                  this.$message.error(this.$t('lang.FastAccess.tryagain'));
                });
            }
          } else {
            checkResult = false;
            return false;
          }
        });
      }
    },
    // 点击选择项目
    setAddType(type) {
      this.addType = type;
    },
    // 获取数据
    getProjectData() {
      if (this.addType === "new") {
        return this.editData;
      } else if (this.addType === "select") {
        return this.$refs.projectSelect.getFormData();
      }
    },
  },
};
</script>
<style scoped>
.add-group {
  margin-top: 50px;
}
.new-group,
.select-group {
  margin-top: 50px;
  display: flex;
}
.check-group {
  cursor: pointer;
  text-decoration: underline;
  color: #409eff;
  margin-left: 30px;
  margin-top: 10px;
}
</style>
